var styles = {
  "Container": "Polaris-IndexFilters-Container"
};

export { styles as default };
